import React, { useState } from "react";
import Navbar from "@/components/cima/Navbar";
import LogoBanner from "@/components/cima/LogoBanner";
import Hero from "@/components/cima/Hero";
import Emergency24Banner from "@/components/cima/Emergency24Banner";
import PromoBanner from "@/components/cima/PromoBanner";
import About from "@/components/cima/About";
import InfraDistributor from "@/components/cima/InfraDistributor";
import Services from "@/components/cima/Services";
import Products from "@/components/cima/Products";
import Safety from "@/components/cima/Safety";
import Testimonials from "@/components/cima/Testimonials";
import ArticleHighlight from "@/components/cima/ArticleHighlight";
import FAQ from "@/components/cima/FAQ";
import Contact from "@/components/cima/Contact";
import Footer from "@/components/cima/Footer";
import WhatsAppFloat from "@/components/cima/WhatsAppFloat";
import QuoteDialog from "@/components/cima/QuoteDialog";

export default function CimaLanding() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteProduct, setQuoteProduct] = useState("");

  const openQuote = (product = "") => {
    setQuoteProduct(product);
    setQuoteOpen(true);
  };

  return (
    <div data-testid="cima-landing" className="min-h-screen bg-white text-slate-900">
      <Navbar onOpenQuote={() => openQuote("")} />
      <LogoBanner />
      <InfraDistributor />
      <Emergency24Banner />
      <PromoBanner onOpenQuote={openQuote} />
      <About />
      <Hero onOpenQuote={() => openQuote("")} />
      <Services />
      <Products onOpenQuote={openQuote} />
      <Safety />
      <Testimonials />
      <ArticleHighlight />
      <FAQ />
      <Contact onOpenQuote={() => openQuote("")} />
      <Footer />
      <WhatsAppFloat />
      <QuoteDialog open={quoteOpen} onOpenChange={setQuoteOpen} defaultProduct={quoteProduct} />
    </div>
  );
}
